import React from "react"
import MenuProducts from "./sub-menus/MenuProducts"
import MenuInsights from "./sub-menus/MenuInsights"
import MenuDevelopers from "./sub-menus/MenuDevelopers"
import MenuAboutFabrick from "./sub-menus/MenuAboutFabrick"
import MenuIndustry from "./sub-menus/MenuIndustry"
// import MenuSupport from "./sub-menus/MenuSupport"

const DesktopHeaderPopup = ({ currentMenu, justOpenedMenu, onClickOutside, closeMenuFunction }) => {
  const alwaysOpen = false
  const isOpen = currentMenu !== '' || alwaysOpen

  return <>
    <div className={`menu ${isOpen ? 'open' : ''} w-[calc(100%-(16px*2))] absolute top-[100%] left-2 flex justify-center`}>
      {/* <div onClick={() => onClickOutside()} className={`menu-backdrop z-[70] ${isOpen ? 'opacity-100' : 'opacity-0'} w-[100vw] max-w-xl h-[calc(100vh)] absolute top-0 -left-2 bg-white/30 truncate backdrop-blur-md`} /> */}
      <div onClick={() => onClickOutside()} className={`menu-backdrop z-[70] ${isOpen ? 'opacity-5' : 'opacity-0'} w-[100vw] max-w-xl h-[calc(100vh)] absolute top-0 -left-2 bg-midnight-10 truncate`} />
      <div className="h-full z-[75] max-w-[1120px] bg-white border-solid border rounded-xl shadow-lg overflow-hidden"
      // onMouseEnter={() => onMouseEnter()}
      // onMouseLeave={() => onMouseLeave()}
      >
        {(justOpenedMenu === 'products') && <MenuSectionWrapper><MenuProducts closeMenuFunction={closeMenuFunction} /></MenuSectionWrapper>}
        {(justOpenedMenu === 'industry') && <MenuSectionWrapper><MenuIndustry closeMenuFunction={closeMenuFunction} /></MenuSectionWrapper>}
        {(justOpenedMenu === 'insights') && <MenuSectionWrapper><MenuInsights closeMenuFunction={closeMenuFunction} /></MenuSectionWrapper>}
        {(justOpenedMenu === 'developers') && <MenuSectionWrapper><MenuDevelopers closeMenuFunction={closeMenuFunction} /></MenuSectionWrapper>}
        {/* { (justOpenedMenu === 'support') && <MenuSectionWrapper><MenuSupport /></MenuSectionWrapper> } */}
        {(justOpenedMenu === 'about-fabrick') && <MenuSectionWrapper><MenuAboutFabrick closeMenuFunction={closeMenuFunction} /></MenuSectionWrapper>}
      </div>
    </div>
  </>
}


const MenuSectionWrapper = ({ children }) => {
  return <div className='grid grid-cols-3'>
    {children}
  </div>
}

export default DesktopHeaderPopup